import createVueComponent from '../createVueComponent';

const Copyright = createVueComponent('CopyrightIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M15 9.4a4 4 0 1 0 0 5.246', key: 'wtyj23' }],
]);

export default Copyright;
